import { FilterOption } from '../../models/Filter';

export default function isDefaultOption(
  defaultOptionsMap: Map<string, FilterOption>,
  filterOption: FilterOption,
): boolean {
  const defaultOption = defaultOptionsMap.get(filterOption.categoryId);

  if (defaultOption === undefined) {
    return false;
  }

  return defaultOption.id === filterOption.id;
}
